import Loader from 'components/Loader';
import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';

import { ExportCreationContextProvider } from '../../hooks/useExportCreationContext';
import { useGetUserProfile } from '../../hooks/useGetUserProfile';
import ExportConfirmation from '../../steps/ExportConfirmation';
import SelectContent from '../../steps/SelectContent';
import SelectRecipient from '../../steps/SelectRecipient';
import SelectPeriod from './steps/SelectPeriod';

const ExportOneOff = () => {
  const { loading: userProfileLoading, user } = useGetUserProfile();

  if (userProfileLoading || !user) {
    return <Loader />;
  }

  const steps: StepOptions[] = [
    {
      key: 'select-recipient',
      render: (props) => <SelectRecipient {...props} />,
    },
    {
      key: 'select-period',
      render: (props) => <SelectPeriod {...props} />,
    },
    {
      key: 'select-content',
      render: (props) => <SelectContent {...props} />,
    },
    {
      key: 'export-confirmation',
      render: (props) => <ExportConfirmation {...props} />,
    },
  ];

  return (
    <ExportCreationContextProvider
      flowConfig={{
        isRecurring: false,
        user,
      }}
    >
      <Stepper steps={steps} />
    </ExportCreationContextProvider>
  );
};

export default ExportOneOff;
